import type { ReactNode } from 'react';

import { ReactComponent as ErrorIcon } from 'assets/images/ui/icon-alert-circle.svg';

import './ErrorInput.scss';

interface IErrorInput {
  children: ReactNode;
}

export const ErrorInput = ({ children }: IErrorInput): JSX.Element => (
  <div className='input__error'>
    <ErrorIcon className='error__icon' />
    <span className='error__description'>{children}</span>
  </div>
);
